import StripeConnectWebView from "@/components/stripe-connect-webview";
import { router, useLocalSearchParams } from "expo-router";
import React from "react";

export default function StripeOnboardingScreen() {
    const params = useLocalSearchParams();

    const onboardingUrl = params.url as string;

    const onComplete = () => {
        router.back();
    }

    const onCancel = () => {
        router.back();
    }

    return (
        <StripeConnectWebView connectUrl={onboardingUrl} onComplete={onComplete} onCancel={onCancel} />
    );
}
